<script setup lang="ts">
import ContactForm from '@/components/contact/ContactForm.vue'
import ImgComponent from '@/components/media/ImgComponent.vue'
import { useContactStore } from '@/store/contact.store'
import HtmlFormatter from '../HtmlFormatter.vue'

const store = useContactStore()
const describe = store.getDescribe
const media = store.getMedia
</script>

<template>
  <div class="flex flex-col rounded-[16px] p-4 lg:p-8 card card--white">
    <div class="row-span-2 flex flex-col justify-end md:justify-start">
      <ContactForm class="row-span-2 mb-4" />
      <div
        class="card card--blue rounded-[8px] p-6"
        v-if="describe && describe.paragraph"
      >
        <h2
          class="color-title-dark text-[22px] md:text-[30px] leading-8 md:leading-10 font-bold text-left lg:mt-0 mb-4"
        >
          {{ describe.paragraph.title }}
        </h2>
        <p class="font-medium leading-[22px] mb-4 lg:mb-0">
          {{ describe.paragraph.copy }}
        </p>
      </div>
    </div>
    <hr class="my-6" />
    <div
      class="card card--blue rounded-[8px] p-6 w-100 flex flex-col xl:flex-row justify-between"
      v-if="media"
    >
      <div class="flex flex-wrap w-full xl:gap-0 gap-4">
        <div class="w-[78%]">
          <h2 class="text-[22px] font-bold mb-4 color-blue">{{ media.title }}</h2>
          <div class="flex flex-col lg:flex-row">
            <div
              class="flex flex-col md:mr-6 w-1/4"
              v-if="media.contactFirstStage || media.buttonText"
            >
              <address class="text-[14px] md:text-[16px] not-italic font-medium">
                <HtmlFormatter
                  v-if="media.contactFirstStage"
                  :html-input="media.contactFirstStage"
                  class="w-max"
                />
              </address>
              <a
                href="tel:123123123"

                class="link link--transparent w-fit font-bold rounded-[8px] mt-4"
                v-if="media.buttonText"
              >
                {{ media.buttonText }}
              </a>
            </div>
            <address
              class="mt-4 lg:mt-0 text-[14px] md:text-[16px] not-italic font-medium md:mr-6 w-1/4"
              v-if="media.contactSecondStage"
            >
              <HtmlFormatter
                :html-input="media.contactSecondStage"
                class="w-max"
              />
            </address>
            <address
              class="mt-4 lg:mt-0 text-[14px] md:text-[16px] not-italic font-medium md:mr-6 w-1/4"
              v-if="media.contactThirdStage"
            >
              <HtmlFormatter
                :html-input="media.contactThirdStage"
                class="w-max"
              />
            </address>
            <address
              class="mt-4 lg:mt-0 text-[14px] md:text-[16px] not-italic font-medium md:mr-6 w-1/4"
              v-if="media.contactFourthStage"
            >
              <HtmlFormatter
                :html-input="media.contactFourthStage"
                class="w-max"
              />
            </address>
          </div>
        </div>
        <ImgComponent v-show="media.image" :src="media.image" class="mr-3 w-1/5 object-contain min-w-[170px] iso" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
hr {
  border-color: var(--vt-c-grey-border);
}

.link {
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--vt-c-text-light);
  padding: 8px 0;
  width: 100%;
  max-width: 262px;

  &--transparent {
    background-color: transparent;
    border: 1px solid var(--vt-c-text-light);
  }
}
.color-blue {
  color: var(--vt-c-text-dark);
}

:deep(.html-formatter) {
  max-width: max-content;
}

</style>
